import ApiService from './ApiService'

export async function apiGetAnalyticsDashboard(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/dashboard',
        method: 'get',
        params: { period },
    })
}

export async function apiGetLiveVisitors() {
    return ApiService.fetchData({
        url: '/analytics/live-visitors',
        method: 'get',
    })
}

export async function apiGetLiveVisitorJourney(key) {
    return ApiService.fetchData({
        url: `/analytics/live-visitors/journey?key=${encodeURIComponent(key)}`,
        method: 'get',
    })
}

export async function apiGetCartActivity() {
    return ApiService.fetchData({
        url: '/analytics/cart-activity',
        method: 'get',
    })
}

export async function apiGetBehaviorPages() {
    return ApiService.fetchData({
        url: '/analytics/behavior/pages',
        method: 'get',
    })
}

// Growth surfaces — Dashboard Redesign, Phase 3
export async function apiGetFunnel(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/funnel',
        method: 'get',
        params: { period },
    })
}

export async function apiGetWishlistAnalytics(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/wishlist',
        method: 'get',
        params: { period },
    })
}

export async function apiGetProductInterest(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/product-interest',
        method: 'get',
        params: { period },
    })
}

export async function apiGetAttribution(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/attribution',
        method: 'get',
        params: { period },
    })
}

export async function apiGetSearchAnalytics(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/search-analytics',
        method: 'get',
        params: { period },
    })
}

export async function apiGetCheckoutSessions(period = '30d') {
    return ApiService.fetchData({
        url: '/analytics/checkout-sessions',
        method: 'get',
        params: { period },
    })
}

export async function apiGetBehavior(params = {}) {
    return ApiService.fetchData({
        url: '/analytics/behavior',
        method: 'get',
        params,
    })
}

export async function apiGetBehaviorPoints(params = {}) {
    return ApiService.fetchData({
        url: '/analytics/behavior/points',
        method: 'get',
        params,
    })
}
